const status = {
  VALIDATING: 'VALIDANDO',
  WAITING: 'AGUARDANDO_RECEBIMENTO',
  RECEIVED: 'RECEBIDO',
  FINISHED: 'FINALIZADO',
  REMOVED: 'REMOVIDO',
  DRAFT: 'RASCUNHO',
  RETURNED: 'DEVOLVIDO',
  BEING_RETURNED: 'EM_DEVOLUCAO',
  WAITING_APPROVAL: 'AGUARDANDO_APROVACAO',
  PENDING: 'PENDENTE'
};

module.exports = status;
